import React from "react";
import {SearchHit} from "../../SearchResult";
import VideoSearchResult from "./VideoSearchResult";
import styles from "./VideoSearchResults.module.css";

interface VideoSearchResultListProps {
    hits?: SearchHit[];
}

export function VideoSearchResultList({hits}: VideoSearchResultListProps) {
    return (
        <div className={styles.list}>
            {hits?.map((hit, index) => (
                <VideoSearchResult
                    key={hit.video.id}
                    highlights={hit.highlights}
                    video={hit.video}
                    isFirst={index === 0}
                />
            ))}
        </div>
    );
}
